import type { CaseStatus } from "../../lib/moderation-api";
import { cn } from "../cn";

export function fmtDate(x: string | null | undefined): string {
  if (!x) return "—";
  const d = new Date(x);
  return Number.isNaN(d.getTime()) ? String(x) : d.toLocaleString();
}

export function shortId(s: string | null | undefined, left = 8, right = 6): string {
  if (!s) return "—";
  return s.length <= left + right + 1 ? s : `${s.slice(0, left)}…${s.slice(-right)}`;
}

const STATUS_STYLE: Record<CaseStatus, { label: string; cls: string; style?: React.CSSProperties }> = {
  MODERATED: { label: "Moderated", cls: "border", style: { color: "var(--neon-coral)", borderColor: "var(--neon-coral-ring)" } },
  REVIEW_PENDING: { label: "Review Pending", cls: "text-neon-teal border border-border-accent bg-neon-teal-soft" },
  RESTORED: { label: "Restored", cls: "text-state-success border border-[color:rgba(88,214,141,0.4)]" },
  INHERITED: { label: "Inherited", cls: "text-text-muted border border-border-soft" },
};

export function StatusBadge({ status, testid }: { status: CaseStatus; testid?: string }) {
  const s = STATUS_STYLE[status] ?? STATUS_STYLE.MODERATED;
  return (
    <span
      data-testid={testid}
      data-status={status}
      className={cn(
        "inline-flex items-center h-5 px-2 rounded-sm font-mono text-[8.5px] font-semibold uppercase tracking-[0.14em] whitespace-nowrap",
        s.cls,
      )}
      style={s.style}
    >
      {s.label}
    </span>
  );
}
